export default __webpack_public_path__ + "static/media/login-blue-bg.url.e022cacea113186ed373597ce450126b.svg";